/**
 * Delete confirmation
 */
import {isSelected} from "./select-checkboxes.js";
import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/attributes/attr/attr.js";
import "dabbyjs/src/attributes/data/data.js";
import "dabbyjs/src/traversal/closest/closest.js";
import "dabbyjs/src/events/on/on.js";

export default obj => {
	if (obj.length) {

		// multi delete confirmation
		$("button[name=action][value=delete],button[name$='[action]'][value=delete]", obj).on("click", function () {
			const name = obj.data("plural");
			if (isSelected(obj, $(this).attr("name"))) {
				return window.confirm(`Are you sure you want to delete the selected ${name}?`);
			} else {
				alert(`Please select which ${name} you would like to delete`);
				return false;
			}
		});

		// delete confirmation
		$("button[name=delete],button[name$='[delete]']", obj).on("click", function () {
			return window.confirm("Are you sure you want to delete this "+$(this).closest("[data-name]").data("name")+"?");
		});
	}
};
